import { useState } from 'react';

import { trackElementInteraction } from '@/common/analytics/gtm/shared/trackElementInteraction';
import FeaturedCollectionsView from '@/modules/HomePage/components/FeaturedCollections/FeaturedCollectionsView';
import useHomepageContext from '@/modules/HomePage/HomePageContext';
import { HomepageFeaturedCollections } from 'generatedBfw/static';

export type FeaturedCollectionsOptionValues = keyof HomepageFeaturedCollections;
interface FeaturedCollectionsOption {
  label: string;
  value: FeaturedCollectionsOptionValues;
}

export const featuredCollectionsOptions: FeaturedCollectionsOption[] = [
  { label: 'Brands', value: 'brands' },
  { label: 'Artists', value: 'artists' },
];

const FeaturedCollections = () => {
  const [activeOption, setActiveOption] = useState(featuredCollectionsOptions[0].value);
  const { featuredCollections } = useHomepageContext();

  const handleChange = (selectedOption: FeaturedCollectionsOptionValues): void => {
    setActiveOption(selectedOption);

    trackElementInteraction({
      elementId:
        selectedOption === 'brands'
          ? 'collections_selector_brands'
          : 'collections_selector_artists',
    });
  };

  if (!featuredCollections?.artists && !featuredCollections?.brands) return null;

  const currentCollections = featuredCollections[activeOption];

  return (
    <FeaturedCollectionsView
      activeOption={activeOption}
      currentCollections={currentCollections}
      handleChangeOption={handleChange}
    />
  );
};

export default FeaturedCollections;
